<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    mail
                </mat-icon>
                <span>
                    Message: {{ itemEnvelope?.Document?.Item?.Name }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit Message: {{ itemEnvelope?.Document?.Item?.MessageId }} - {{ itemEnvelope?.Document?.Item?.Name }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div style="display: flex;flex-direction: column;">
                <app-chip-selector #fromChipSelector
                                   idLinkPath="contact"
                                   label="From"
                                   className="width-medium-narrow"
                                   [isMultiSelect]="false"
                                   [availableItems]="availableContacts"
                                   [value]="fromContactIds"
                                   [disabled]="true">
                </app-chip-selector>
                <span>
                    <app-chip-selector #toChipSelector
                                       idLinkPath="contact"
                                       label="To"
                                       className="width-medium-narrow"
                                       [isMultiSelect]="true"
                                       [availableItems]="availableContacts"
                                       [value]="toContactIds"
                                       [disabled]="false">
                    </app-chip-selector>
                    <button mat-button (click)="toggleCcBccFieldVisibility()">
                        <mat-icon class="material-symbols-outlined" matTooltip="Toggle CC and BCC fields">
                            {{ ccBccToggleButtonDynamicIconName }}
                        </mat-icon>
                    </button>
                </span>
                <div class="{{ ccBccDivDynamicClassName }}">
                    <app-chip-selector #ccChipSelector
                                       idLinkPath="contact"
                                       label="CC"
                                       className="width-medium-narrow"
                                       [isMultiSelect]="true"
                                       [availableItems]="availableContacts"
                                       [value]="ccContactIds"
                                       [disabled]="false">
                    </app-chip-selector>
                    <app-chip-selector #bccChipSelector
                                       idLinkPath="contact"
                                       label="BCC"
                                       className="width-medium-narrow"
                                       [isMultiSelect]="true"
                                       [availableItems]="availableContacts"
                                       [value]="bccContactIds"
                                       [disabled]="false">
                    </app-chip-selector>
                </div>
                <mat-form-field appearance="outline">
                    <mat-label>Subject</mat-label>
                    <input *ngIf="itemEnvelope" matInput name="Subject" placeholder="Message subject" [(ngModel)]="$any(itemEnvelope).Document.Item.Subject" />
                </mat-form-field>
            </div>
            <mat-tab-group>
                <br />
                <mat-tab label="Message">
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>Format</mat-label>
                        <mat-select name="bodyFormat" [(ngModel)]="selectedMessageFormat">
                            <mat-option *ngFor="let messageFormat of availableMessageFormats" [value]="messageFormat.Id">{{ messageFormat.UID }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <br />
                    <mat-form-field style="width:100%;height: 40%;" appearance="outline">
                        <mat-label>Body</mat-label>
                        <textarea matInput name="messageBody" rows="20" placeholder="" [(ngModel)]="itemEnvelope!.Document!.Item!.Body!" style="font-family: 'Source Code Pro', monospace;"></textarea>
                    </mat-form-field>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>



